import React from 'react';
import type { Theme } from 'baseui';
import { useStyletron } from 'baseui';
import { Tag } from 'baseui/tag';
import type { RangeSpanT } from '../../../../../../../common/types/types';
import { TimeDisplayMode } from '../../../../../../types';
import { getFrameToTime } from '../../../../../../utils/frame-time';
type PropsT = {
  annotationSequence: Map<string, RangeSpanT>;
  timeDisplayMode: TimeDisplayMode;
  frameRate: number | null | undefined;
  maxFrames: number;
};
const getTagOverrides = (theme: Theme) => ({
  Root: {
    style: {
      margin: 0,
      fontSize: theme.typography.LabelXSmall.fontSize
    }
  },
  Text: {
    style: ({
      $theme
    }) => ({
      fontSize: $theme.typography.LabelXSmall.fontSize
    })
  }
});
const getRangeDisplay = (range: RangeSpanT, timeDisplayMode: TimeDisplayMode, frameRate: number | null | undefined, maxFrames: number) => {
  const {
    start,
    end
  } = range;
  const startTime = getFrameToTime({
    frame: start,
    maxFrames,
    frameRate
  });
  const endTime = getFrameToTime({
    frame: end,
    maxFrames,
    frameRate
  });
  const isDisplayModeFrames = timeDisplayMode === TimeDisplayMode.FRAMES;
  if (startTime === endTime) {
    return isDisplayModeFrames ? `${start + 1}` : `${startTime}`;
  }
  return isDisplayModeFrames ? `${start + 1} - ${end + 1}` : `${startTime} - ${endTime}`;
};
export const ExistingSequences = ({
  annotationSequence,
  timeDisplayMode,
  frameRate,
  maxFrames
}: PropsT) => {
  const [css, theme] = useStyletron();
  if (annotationSequence.size === 0) {
    return null;
  }
  return <>
      <div className={css({
      fontSize: theme.typography.LabelSmall.fontSize,
      color: theme.colors.contentSecondary,
      padding: theme.sizing.scale0
    })}>
        Existing Sequences
      </div>
      <div className={css({
      display: 'flex',
      flexWrap: 'wrap',
      padding: theme.sizing.scale100,
      gap: theme.sizing.scale200
    })}>
        {Array.from(annotationSequence).map(([sequenceId, range]: [string, RangeSpanT]) => {
        const rangeDisplay = getRangeDisplay(range, timeDisplayMode, frameRate, maxFrames);
        return <Tag key={sequenceId} closeable={false} kind="accent" overrides={getTagOverrides(theme)}>
              {rangeDisplay}
            </Tag>;
      })}
      </div>
    </>;
};